import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import {
  ISeedDeliveryRegions,
  ISeedDeliveryRegionsUpdate,
} from "../types/deliveryRegion";

const API = process.env.REACT_APP_API;

/**
 * Hook para buscar as regiões de entrega selecionadas da seed
 */
export const useSeedDeliveryRegions = () => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["seed-delivery-regions"],
    queryFn: async () => {
      try {
        const response = await fetch(
          `${API}/api/semeadora/seed-delivery-regions/`,
          {
            method: "GET",
          },
        );
        return response as ISeedDeliveryRegions;
      } catch (error) {
        console.error("Erro ao buscar regiões de entrega da seed:", error);
        throw new Error(
          "Não foi possível carregar suas regiões de entrega. Por favor, recarregue a página.",
        );
      }
    },
    retry: 2,
    retryDelay: 1000,
  });
};

/**
 * Hook para atualizar as regiões de entrega da seed
 */
export const useUpdateSeedDeliveryRegions = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (regionIds: number[]) => {
      try {
        const response = await fetch(
          `${API}/api/semeadora/seed-delivery-regions/`,
          {
            method: "POST",
            body: { region_ids: regionIds },
          },
        );
        return response as ISeedDeliveryRegionsUpdate;
      } catch (error: any) {
        console.error("Erro ao atualizar regiões de entrega:", error);

        // Tenta extrair mensagem de erro do backend
        const errorMessage =
          error?.message ||
          error?.detail ||
          "Não foi possível salvar as regiões de entrega. Por favor, tente novamente.";

        throw new Error(errorMessage);
      }
    },
    onSuccess: () => {
      // Invalida a query para forçar recarregamento
      queryClient.invalidateQueries(["seed-delivery-regions"]);
    },
  });
};
